export var Labels={paymentOptionDivider:"\u3082\u3057\u304f\u306f"};